import { makeStyles } from '@mui/styles';
import { buildVariant } from 'src/utils/mui';

export const useStyles = makeStyles(theme => ({
    title: {
        ...buildVariant('bold', 24, 'textPrimary'),
        lineHeight: 1.25,
        maxWidth: 600,
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            ...buildVariant(600, 16, 'textPrimary')
        }
    },
    wrapper: {
        paddingTop: 222,
        width: 600,
        position: 'absolute',
        transform: 'translateY(-55%)',
        top: '40%',
        [theme.breakpoints.down('sm')]: {
            width: 335
        }
    },
    loginTitle: {
        fontWeight: 'normal',
        margin: '10px 0 25px',
        lineHeight: 1.63,
        letterSpacing: 'normal',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            ...buildVariant(400, 14)
        }
    },
    button: {
        marginTop: 25,
        width: 500,
        height: 50,
        fontSize: 16
    },
    circularProgress: {
        color: 'white',
        position: 'unset',
        marginLeft: 10
    },
    loadingButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}));
